import React from 'react';
import {orgId} from '../../../context/context';
import OpenInNewLink from '../../../libs/react-components-admin/link/open-in-new-link';

const Step1 = () => {

  return <ul style={{lineHeight: '1.8em'}}>
    <li>
      Open your <OpenInNewLink href={`https://${orgId}/admin/themes/current/editor`}>theme
      editor</OpenInNewLink>
    </li>
    <li>
      From the template dropdown or Search icon (top of the page, in the middle), choose &apos;Products&apos; and create a new
      template.
    </li>
    <li>
      In the left panel, click on &apos;Add block&apos; or &apos;Add section&apos;, scroll down and choose &apos;Custom Form&apos;:<br/>
      <img src="/images/osv2-apps-custom-form.png" alt=""/>
    </li>
    <li>
      Click on &apos;Custom Form&apos; to reveal the configuration panel (it might appear on the opposite side of the
      page).<br/>
      Choose Behavior: &apos;Product page - add values to order&apos;.
    </li>
    <li>
      Click on &apos;Save&apos; (top right) &gt; Exit (top left) &gt; &apos;Products&apos; and click on one of the products.
    </li>
    <li>
      Under &apos;Online store&apos; &gt; &apos;Theme template&apos; (bottom right panel), choose the template from step 2 in the dropdown.
      Click on &apos;Save&apos; then &apos;Preview&apos; (top right).
    </li>
  </ul>;
};

export default Step1;
